import authFetch from './fetch';
import { makeRequest, getQueryParams } from './utils';

const routes = {
  repairIssuesPath: () => '/api/RepairIssues/',
  repairIssuesSearchPropsPath: () => `${routes.repairIssuesPath()}SearchProperties`,
  repairIssueAuditsPathById: (id, params) => `${routes.repairIssuesPath()}${id}/Audits${getQueryParams(params)}`,
  repairIssueAuditPropertiesPathById: (id) => `${routes.repairIssuesPath()}${id}/Audits/Properties`,
  repairIssueAuditUsersPathById: (id) => `${routes.repairIssuesPath()}${id}/Audits/Users`,
  getRepairIssuePathById: (id) => `${routes.repairIssuesPath()}${id}`,
  restoreRepairIssuePathById: (id) => `${routes.repairIssuesPath()}${id}/restore`,
  deleteRepairIssuePathById: (id) => `${routes.repairIssuesPath()}${id}`,
};

export const getRepairIssuesSearchProps = (params) => makeRequest(authFetch.get(routes.repairIssuesSearchPropsPath()));

export const getRepairIssues = (params) => makeRequest(authFetch.get(`${routes.repairIssuesPath()}${getQueryParams(params)}`));

export const getRepairIssue = (id) => makeRequest(authFetch.get(routes.getRepairIssuePathById(id)));
export const putRepairIssue = (data) => makeRequest(authFetch.put(routes.repairIssuesPath(), data));

export const deleteRepairIssue = (id) => makeRequest(authFetch.delete(routes.deleteRepairIssuePathById(id)));
export const restoreRepairIssue = (id) => makeRequest(authFetch.patch(routes.restoreRepairIssuePathById(id)));

export const getRepairIssueAudits = (id, params) => makeRequest(authFetch.get(routes.repairIssueAuditsPathById(id, params)));
export const getRepairIssueAuditProperties = (id) => makeRequest(authFetch.get(routes.repairIssueAuditPropertiesPathById(id)));
export const getRepairIssueAuditUsers = (id) => makeRequest(authFetch.get(routes.repairIssueAuditUsersPathById(id)));
